import '../styles.scss'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import B2becButton from '@/components/B2becButton'
import { linkGenerator } from '@/libs/utils/language'

const BottomSectionComponent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="order-confirm__main__bottom">
      <span className="order-confirm__main__bottom__title">
        {t('checkout.confirmOrder.whatNext')}
      </span>
      <div className="order-confirm__main__bottom__button-group">
        <div className="order-confirm__main__bottom__panel order-confirm__main__bottom__left">
          <B2becButton
            block
            onClick={() => {
              navigate(linkGenerator('/orders'))
            }}
          >
            {t('checkout.confirmOrder.seeOrderHistory')}
          </B2becButton>
        </div>
        <div className="order-confirm__main__bottom__panel order-confirm__main__bottom__right">
          <B2becButton
            block
            ghost
            onClick={() => {
              navigate(linkGenerator('/my-workspace'))
            }}
          >
            {t('sidebar.myWorkspace')}
          </B2becButton>
        </div>
      </div>
    </div>
  )
}
export default BottomSectionComponent
